import { Helmet } from "react-helmet-async";
import { useContext, useEffect, useState } from "react";
import Aos from "aos";
import axios from "axios";
import Header from "../../components/Header/Header";
import Footer2 from "../../components/Footer/Footer2";
import Div from "../../components/utils/Div";
import { domainProvider } from "../../contexts/DomainContext";
import LoginForm from "./LoginForm";
import LoginImage from "./LoginImage";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { t } = useTranslation();
  const { titleName } = useContext(domainProvider);
  const [general, setGeneral] = useState({});
  const selectLanguage = i18next.language;
  const navigate = useNavigate()

  useEffect(() => {
    Aos.init();
    Aos.refresh();
    axios
      .get(`${process.env.REACT_APP_APIURL}/admin/getgeneraldetails`)
      .then((res) => {
        setGeneral(res.data.data[0]);
      });
  }, []);
  useEffect(() => {
    var user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (
      user && user.token
        ? user.token
        : user && user.refreshToken
          ? user.refreshToken
          : ""
    ) {
      navigate("/vendor/main-flow");
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Sign In - {titleName}</title>
        {general?.favicon && <link rel="icon" href={general.favicon} />}
      </Helmet>

      <Header />

      <Div
        id="privacyPolicy"
        style={{ direction: selectLanguage === "ar" ? "rtl" : "ltr" }}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 place-content-center mx-auto mt-7">
          <div
            className={`flex-1 mx-auto ${selectLanguage === "ar" ? "md:border-l-4" : "md:border-r-4"
              } border-gray-200 px-2 w-full`}
          >
            <LoginForm />
          </div>
          <LoginImage />
        </div>
      </Div>

      <Footer2 />
    </>
  );
};

export default Login;
